import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface PropertyDescriptionsObject {
  id: number;
  titleEn: string;
  titleAr: string;
  slug: string;
  isActive: boolean;
}

export interface PropertyDescriptionsListInfo {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  isNext: boolean;
  previous: number;
  descriptions: Array<PropertyDescriptionsObject>;
  errors: unknown;
}

@Module
export default class PropertyDescriptionsModule
  extends VuexModule
  implements PropertyDescriptionsListInfo
{
  descriptions = [] as Array<PropertyDescriptionsObject>;
  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  previous = 0;
  isNext = true;
  errors = {};

  /**
   * Get areas list
   * @returns Array<AreaObject>
   */
  get descriptionsList(): Array<PropertyDescriptionsObject> {
    return this.descriptions;
  }

  /**
   * Get all none ive areas list
   * @returns Array<AreaObject>
   */
  get allListPropertyDescriptions(): Array<PropertyDescriptionsObject> {
    return this.descriptions;
  }

  /**
   * Get total items
   * @returns number
   */
  get propertyDescriptionsListCount(): number {
    return this.totalItems;
  }

  @Mutation
  [Mutations.SET_PROPERTY_DESCRIPTIONS](data) {
    this.descriptions = data.data;
    this.totalItems = data.totalItems;
    this.currentPage = data.currentPage;
    this.pageSize = data.pageSize;
    this.isNext = data.isNext;
    this.previous = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_PROPERTY_DESCRIPTIONS_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Mutation
  [Mutations.RESET_PROPERTY_DESCRIPTIONS_LIST]() {
    this.descriptions = [] as Array<PropertyDescriptionsObject>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  @Action
  [Actions.RESET_PROPERTY_DESCRIPTIONS_STORE]() {
    this.context.commit(Mutations.RESET_PROPERTY_DESCRIPTIONS_LIST);
  }

  @Action
  [Actions.CREATE_PROPERTY_DESCRIPTION](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/settings/trades-property-description', data)
      .then(() => {
        this.context.commit(Mutations.RESET_PROPERTY_DESCRIPTIONS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.DELETE_PROPERTY_DESCRIPTION](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/settings/trades-property-description', id)
      .then(() => {
        this.context.commit(Mutations.RESET_AREAS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_PROPERTY_DESCRIPTION]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/settings/trades-property-description', id, data)
      .then(() => {
        this.context.commit(Mutations.RESET_PROPERTY_DESCRIPTIONS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_PROPERTY_DESCRIPTION_CURRENT_PAGE](val) {
    this.context.commit(Mutations.GET_PROPERTY_DESCRIPTION_CURRENT_PAGE, val);
  }

  @Action
  [Actions.GET_PROPERTY_DESCRIPTIONS]() {
    ApiService.setAuthorizationHeader();
    return ApiService.query('/settings/trades-property-description', {
      params: { page: this.currentPage },
    })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_PROPERTY_DESCRIPTIONS, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }

  @Action
  [Actions.GET_PROPERTY_DESCRIPTION](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get(`/settings/trades-property-description`, id);
  }
}
